import { __rest, __read, __assign } from './../../../external_lib/tslib/tslib.es6.js';
import classNames from './../../../external_lib/classnames/index.js';
import React__default, { forwardRef, useState } from 'react';
import EyeOpen from '../../../assets/icons/jsx/EyeOpen.js';
import EyeClose from '../../../assets/icons/jsx/EyeClose.js';
import styles from './index.module.scss.js';
import AntInput from './../../../external_lib/antd/es/input/index.js';
var CustomPasswordInput = forwardRef(function (_a, ref) {
  var className = _a.className,
    _b = _a.value,
    value = _b === void 0 ? '' : _b,
    onChange = _a.onChange,
    restProps = __rest(_a, ["className", "value", "onChange"]);
  var stringValue = String(value);
  var _c = __read(useState(false), 2),
    isVisible = _c[0],
    setIsVisible = _c[1];
  var displayValue = isVisible ? stringValue : '*'.repeat(stringValue.length);
  var handleChange = function (e) {
    var input = e.target.value;
    var newRealValue = stringValue;
    if (input.length === 0) {
      newRealValue = '';
    } else if (input.length > 0 && input.replace(/\*/g, '').length === input.length) {
      newRealValue = input;
    } else if (input.length < stringValue.length) {
      newRealValue = stringValue.slice(0, input.length);
    } else if (input.length > stringValue.length) {
      var typedChar = input.replace(/\*/g, '').slice(-1);
      newRealValue = stringValue + typedChar;
    }
    onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, e), {
      target: __assign(__assign({}, e.target), {
        value: newRealValue
      })
    }));
  };
  return React__default.createElement(AntInput, __assign({
    ref: ref,
    autoComplete: "off",
    value: displayValue,
    onChange: handleChange,
    className: classNames(styles.horizonInput, 'custom-password-input', !isVisible && 'custom-password-masked', className),
    suffix: isVisible ? React__default.createElement(EyeClose, {
      className: "cursor-pointer",
      onClick: function () {
        return setIsVisible(false);
      }
    }) : React__default.createElement(EyeOpen, {
      className: "cursor-pointer",
      onClick: function () {
        return setIsVisible(true);
      }
    })
  }, restProps));
});
export { CustomPasswordInput as default };
//# sourceMappingURL=CustomPasswordInput.js.map
